<template>
    <section class="container">
        <div class="d-flex justify-content-center">
            <img src="/static/img/survey/BeNeat-New-Logo-2021.png" :width="$mq.phone? '350':'500'" alt="...">
        </div>
        <div class="text-center">
            <template v-if="$mq.phone">
                <h3>แบบฟอร์มลงทะเบียนเข้าร่วมวิจัย <br> เพื่อพัฒนาประสบการณ์ <br> "การเรียกใช้บริการคุณแม่บ้านทําความสะอาด” <br> ผ่านแอปพลิเคชั่น BeNeat</h3>
            </template>
            <template v-else>
                <h2>แบบฟอร์มลงทะเบียนเข้าร่วมวิจัย เพื่อพัฒนาประสบการณ์ <br> "การเรียกใช้บริการคุณแม่บ้านทําความสะอาด” ผ่านแอปพลิเคชั่น BeNeat</h2>
            </template>
        </div>
        <div>
            <form data-vv-scope="form-user-focus-group" @submit.prevent="formSubmit()">
                <div class="form-group">
                    <label><span class="text-danger">*</span>หมายเลขโทรศัพท์</label>
                    <input type="number"
                            class="form-control input-jumbo"
                            :class="{'form-alert': errors.has('form-user-focus-group.tel')}"
                            :style="$mq.phone ? '' : 'width:40%'"
                            id="tel"
                            name="tel"
                            v-model="form.tel"
                            v-validate="'required'"
                            >
                    <div class="mt-1 text-remark -status-alert" v-if="errors.has('form-user-focus-group.tel')">
                        {{ $t('message.required_field') }}
                    </div>
                </div>
                <div class="form-group">
                    <label for="gender"><span class="text-danger">*</span>เพศ (Gender)</label>
                    <div class="row no-gutters pl-2">
                        <div class="exp col-12">
                            <div class="checkbox">
                              <input type="radio"
                                     name="gender"
                                     id="man"
                                     value="เพศชาย"
                                     v-validate="'required'"
                                     v-model="form.gender"/>
                              <label class="mb-3" for="man">
                                <span> </span>
                                เพศชาย (Male)
                              </label>
                            </div>
                        </div>
                        <div class="exp col-12">
                            <div class="checkbox">
                              <input type="radio"
                                     name="gender"
                                     id="women"
                                     value="เพศหญิง"
                                     v-validate="'required'"
                                     v-model="form.gender"/>
                              <label class="mb-3" for="women">
                                <span> </span>
                                เพศหญิง (Female)
                              </label>
                            </div>
                        </div>
                        <div class="exp col-12">
                            <div class="checkbox">
                              <input type="radio"
                                     name="gender"
                                     id="other"
                                     value="other"
                                     v-validate="'required'"
                                     v-model="form.gender"/>
                              <label class="mb-3" for="other">
                                <span> </span>
                                ไม่ระบุ (Other)
                              </label>
                            </div>
                        </div>
                    </div>
                    <div class="mt-1 text-remark -status-alert" v-if="errors.has('form-user-focus-group.gender')">
                        {{ $t('message.required_field') }}
                    </div>
                </div>
                <div class="form-group">
                    <label><span class="text-danger">*</span>อายุ (Age)</label>
                    <div class="row no-gutters pl-2">
                        <div class="exp col-12">
                            <div class="checkbox">
                                <input type="radio"
                                        name="age"
                                        id="age_20_30"
                                        value="20-30"
                                        v-validate="'required'"
                                        v-model="form.age"/>
                                <label class="mb-3" for="age_20_30">
                                <span> </span>
                                20-30 ปี
                                </label>
                            </div>
                        </div>
                        <div class="exp col-12">
                            <div class="checkbox">
                                <input type="radio"
                                        name="age"
                                        id="age_31_40"
                                        value="31-40"
                                        v-validate="'required'"
                                        v-model="form.age"/>
                                <label class="mb-3" for="age_31_40">
                                <span> </span>
                                31-40 ปี
                                </label>
                            </div>
                        </div>
                        <div class="exp col-12">
                            <div class="checkbox">
                                <input type="radio"
                                        name="age"
                                        id="age_41_50"
                                        value="41-50"
                                        v-validate="'required'"
                                        v-model="form.age"/>
                                <label class="mb-3" for="age_41_50">
                                <span> </span>
                                41-50 ปี
                                </label>
                            </div>
                        </div>
                        <div class="exp col-12">
                            <div class="checkbox">
                                <input type="radio"
                                        name="age"
                                        id="age_51_60"
                                        value="51-60"
                                        v-validate="'required'"
                                        v-model="form.age"/>
                                <label class="mb-3" for="age_51_60">
                                <span> </span>
                                51-60 ปี
                                </label>
                            </div>
                        </div>
                        <div class="exp col-12">
                            <div class="checkbox">
                                <input type="radio"
                                        name="age"
                                        id="age_61"
                                        value="61"
                                        v-validate="'required'"
                                        v-model="form.age"/>
                                <label class="mb-3" for="age_61">
                                <span> </span>
                                มากกว่า 61 ปี
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="mt-1 text-remark -status-alert" v-if="errors.has('form-user-focus-group.age')">
                        {{ $t('message.required_field') }}
                    </div>
                </div>
                <div class="form-group">
                    <label><span class="text-danger">*</span>สถานภาพ (State of life)</label>
                    <div class="row no-gutters pl-2">
                        <div class="exp col-12">
                            <div class="checkbox">
                                <input type="radio"
                                        name="state_of_life"
                                        id="single"
                                        value="single"
                                        v-validate="'required'"
                                        v-model="form.state_of_life"/>
                                <label class="mb-3" for="single">
                                <span> </span>
                                โสด (Single)
                                </label>
                            </div>
                        </div>
                        <div class="exp col-12">
                            <div class="checkbox">
                                <input type="radio"
                                        name="state_of_life"
                                        id="married"
                                        value="married"
                                        v-validate="'required'"
                                        v-model="form.state_of_life"/>
                                <label class="mb-3" for="married">
                                <span> </span>
                                แต่งงาน (Married)
                                </label>
                            </div>
                        </div>
                        <div class="exp col-12">
                            <div class="checkbox">
                                <input type="radio"
                                        name="state_of_life"
                                        id="divorce"
                                        value="divorce"
                                        v-validate="'required'"
                                        v-model="form.state_of_life"/>
                                <label class="mb-3" for="divorce">
                                <span> </span>
                                หย่าร้าง/หม้าย (Divorce)
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="mt-1 text-remark -status-alert" v-if="errors.has('form-user-focus-group.state_of_life')">
                        {{ $t('message.required_field') }}
                    </div>
                </div>
                <div class="form-group" v-if="form.state_of_life === 'single'">
                    <label>โสด (Single)</label>
                    <div class="row no-gutters pl-2">
                        <div class="exp col-12">
                            <div class="checkbox">
                                <input type="radio"
                                        name="single_detail"
                                        id="live_alone"
                                        value="live_alone"
                                        v-model="form.single_detail"/>
                                <label class="mb-3" for="live_alone">
                                <span> </span>
                                อยู่คนเดียว (Live alone)
                                </label>
                            </div>
                        </div>
                        <div class="exp col-12">
                            <div class="checkbox">
                                <input type="radio"
                                        name="single_detail"
                                        id="with_family"
                                        value="with_family"
                                        v-model="form.single_detail"/>
                                <label class="mb-3" for="with_family">
                                <span> </span>
                                อยู่กับครอบครัว (With family)
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group" v-if="form.state_of_life === 'married'">
                    <label>แต่งงาน (Married)</label>
                    <div class="row no-gutters pl-2">
                        <div class="exp col-12">
                            <div class="checkbox">
                                <input type="radio"
                                        name="married_detail"
                                        id="one_child"
                                        value="one_child"
                                        v-model="form.married_detail"/>
                                <label class="mb-3" for="one_child">
                                <span> </span>
                                มีลูก 1 คน (One child)
                                </label>
                            </div>
                        </div>
                        <div class="exp col-12">
                            <div class="checkbox">
                                <input type="radio"
                                        name="married_detail"
                                        id="more_than_1_child"
                                        value="more_than_1_child"
                                        v-model="form.married_detail"/>
                                <label class="mb-3" for="more_than_1_child">
                                <span> </span>
                                มีลูกมากกว่า 1 คน (More than 1 child)
                                </label>
                            </div>
                        </div>
                        <div class="exp col-12">
                            <div class="checkbox">
                                <input type="radio"
                                        name="married_detail"
                                        id="no_child"
                                        value="no_child"
                                        v-model="form.married_detail"/>
                                <label class="mb-3" for="no_child">
                                <span> </span>
                                ไม่มีลูก (No child)
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="salary">รายได้เฉลี่ยต่อเดือน (Average monthly income)</label>
                    <div class="row no-gutters pl-2">
                        <div class="exp col-12">
                            <div class="checkbox">
                              <input type="radio"
                                     name="salary"
                                     id="s_15_20"
                                     value="15000-20000"
                                     v-model="form.salary"/>
                              <label class="mb-3" for="s_15_20">
                                <span> </span>
                                15,000 - 20,000 บาท
                              </label>
                            </div>
                        </div>
                        <div class="exp col-12">
                            <div class="checkbox">
                              <input type="radio"
                                     name="salary"
                                     id="s_20_30"
                                     value="20001-30000"
                                     v-model="form.salary"/>
                              <label class="mb-3" for="s_20_30">
                                <span> </span>
                                20,001 - 30,000 บาท
                              </label>
                            </div>
                        </div>
                        <div class="exp col-12">
                            <div class="checkbox">
                              <input type="radio"
                                     name="salary"
                                     id="s_30_40"
                                     value="30001-40000"
                                     v-model="form.salary"/>
                              <label class="mb-3" for="s_30_40">
                                <span> </span>
                                30,001 - 40,000 บาท
                              </label>
                            </div>
                        </div>
                        <div class="exp col-12">
                            <div class="checkbox">
                              <input type="radio"
                                     name="salary"
                                     id="s_40_50"
                                     value="40001-50000"
                                     v-model="form.salary"/>
                              <label class="mb-3" for="s_40_50">
                                <span> </span>
                                40,001 - 50,000 บาท
                              </label>
                            </div>
                        </div>
                        <div class="exp col-12">
                            <div class="checkbox">
                              <input type="radio"
                                     name="salary"
                                     id="s_50"
                                     value="50001"
                                     v-model="form.salary"/>
                              <label class="mb-3" for="s_50">
                                <span> </span>
                                มากกว่า 50,001 บาท
                              </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-center pb-5">
                    <button type="submit" class="btn btn__submit btn-lg px-5 mt-3">
                        Submit
                    </button>
                </div>
            </form>
        </div>
    </section>
</template>
<script>
import axios from 'axios'
export default {
  data: () => ({
    form: {
      tel: null,
      gender: null,
      age: null,
      salary: null,
      admin_id: null,
      state_of_life: null,
      single_detail: null,
      married_detail: null
    }
  }),
  methods: {
    formSubmit () {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.save()
        }
      })
    },
    async save () {
      this.form.user_id = this.$route.query.user_id
      const { data } = await axios.post('/surveys/form/1', {
        user_id: this.$route.query.user_id,
        data: this.form,
        type: 'survey_1'
      })
      if (!data.error) {
        this.$swal({
          type: 'success',
          title: 'ลงทะเบียนสำเร็จ',
          text: 'BeNeat ขอขอบคุณท่านที่ให้ความสนใจเข้าร่วมโครงการ หากประสบการณ์ของท่าน ตรงกับกลุ่ม Focus Group ของงานวิจัย ทางทีมวิจัยจะติดต่อกลับท่านเพื่อเชิญเข้าร่วมวิจัยอีกครั้ง',
          showConfirmButton: false,
          showCloseButton: true
        })
      } else {
        this.$swal({
          type: 'error',
          title: 'ขออภัยในความไม่สะดวก',
          text: 'BeNeat ขอขอบคุณท่านที่ให้ความสนใจเข้าร่วมโครงการ คุณลูกค้าไม่ตรงกับกลุ่ม Focus Group ของงานวิจัย ทางทีมวิจัยจะติดต่อกลับท่านเพื่อเชิญเข้าร่วมวิจัยอีกครั้ง',
          showConfirmButton: false,
          showCloseButton: true
        })
      }
    }
  }
}
</script>
<style scoped>
.btn__submit {
    background-color: #3cc1d8;
    color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/survey/UserFocusGroup.vue